import { atom } from 'jotai';
import { InstanceTier, DockerImage } from '@/types';

// Docker build images
export const dockerImagesAtom = atom<DockerImage[]>([]);
export const dockerImagesLoadingAtom = atom<boolean>(false);
export const dockerImagesErrorAtom = atom<string | null>(null);

// Separate atoms for each tier to prevent cross-tier re-renders
export const standardInstanceAtom = atom<InstanceTier | null>(null);
export const ultraInstanceAtom = atom<InstanceTier | null>(null);

export const standardLoadingAtom = atom({
  fetch: false,
  create: false,
  delete: false,
});

export const ultraLoadingAtom = atom({
  fetch: false,
  create: false,
  delete: false,
});

export const standardErrorAtom = atom<string | null>(null);
export const ultraErrorAtom = atom<string | null>(null);

// Helper function to get atoms for a specific tier
export const getAtomsForTier = (tier: string) => {
  switch (tier) {
    case 'standard':
      return {
        instanceAtom: standardInstanceAtom,
        loadingAtom: standardLoadingAtom,
        errorAtom: standardErrorAtom,
      };
    case 'ultra':
      return {
        instanceAtom: ultraInstanceAtom,
        loadingAtom: ultraLoadingAtom,
        errorAtom: ultraErrorAtom,
      };
    default:
      return {
        instanceAtom: standardInstanceAtom,
        loadingAtom: standardLoadingAtom,
        errorAtom: standardErrorAtom,
      };
  }
};
